export default "__VITE_ASSET__BDttQGAm__"